import { NestedKeyAccessor } from 'record-it-utils/utils/utilityTypes/NestedKeyAccessor';
import { NestedKeys } from 'record-it-utils/utils/utilityTypes/NestedKeys';
import { Config } from './SiteConfig';

export class SiteConfigUtils {
  private constructor() {}

  public static getValue<TKey extends NestedKeys<Config>>(
    config: Config,
    key: TKey
  ): NestedKeyAccessor<Config, TKey> {
    const parts = key.split('.');
    const currentPath: Array<string> = [];

    let currentValue: unknown = config;

    for (const part of parts) {
      currentPath.push(part);

      if (!(currentValue instanceof Object)) {
        throw new Error(
          `failed at ${currentPath.join('.')}: the value is not an object. full path: ${key}`
        );
      }

      if (!Object.keys(currentValue).includes(part)) {
        throw new Error(
          `failed at ${currentPath.join('.')}: the value doesn't contain the key ${part}. full path: ${key}`
        );
      }

      currentValue = (currentValue as any)[part];
    }

    return currentValue as any;
  }
}
